module.exports = __webpack_public_path__ + "media/images/austrian/offers/digital-voucher2x-b09ac59d93ffc1beaea4890425ac7186.jpg";